<template>
  <div class="app">
    <navbarsection />
    <router-view />
    <footerpage />
  </div>
</template>

<script>
import navbarsection from "@/components/navbarsection";
import footerpage from "@/components/footerpage";

export default {
  name: "App",
  components: {
    navbarsection,
    footerpage
  }
};
</script>
